export default "__VITE_ASSET__f85f8ab3__"